import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=72ee331a&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ee331a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72ee331a')) {
      api.createRecord('72ee331a', component.options)
    } else {
      api.reload('72ee331a', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=72ee331a&scoped=true&", function () {
      api.rerender('72ee331a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Cm6A52qOq9HJ/JS/comp/SearchFilterTokens.vue"
export default component.exports